import React from 'react';
import * as PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { injectIntl } from 'react-intl';
import size from 'lodash/size';

import Popup from '../Popup';
import Icon from '../../Icon';
import Button from '../../Button';
import CollapsedSendMessageItem from '../CollapsedSendMessageItem';
import { BREAKPOINT } from '../../../constants/styles';
import Loader from '../Loader';

const CollapsedSendMessagePopup = ({
  profiles,
  icon,
  description,
  opened,
  loading,
  onClose,
  onSubmit,
  intl: { formatMessage },
}) => {
  const profilesSize = size(profiles) - 1;

  return (
    <MediaQuery maxWidth={BREAKPOINT}>
      {isMobile => (
        <Popup
          opened={opened}
          onClose={onClose}
          width={isMobile ? 'medium' : 'xsmall'}
          enabled
        >
          <div className="pl3 pr3 pb3">
            <div className="flex flex-column items-center">
              <If condition={icon}>
                <Icon className="mb3" name={icon} height={48} width={48} />
              </If>
              <If condition={description}>
                <span className="mb3 tc">{description}</span>
              </If>
            </div>
            {loading && <Loader />}
            {profiles.map((item, i) => (
              <CollapsedSendMessageItem
                key={item.id}
                profile={item}
                withLine={i !== profilesSize}
                onSubmit={message => onSubmit(message, item.id)}
              />
            ))}
            <div className="mt3 flex flex-column items-center">
              <Button color="primary" raised onClick={onClose}>
                {formatMessage({ id: 'submit.expiredToken' })}
              </Button>
            </div>
          </div>
        </Popup>
      )}
    </MediaQuery>
  );
};

CollapsedSendMessagePopup.propTypes = {
  profiles: PropTypes.array,
  icon: PropTypes.string,
  description: PropTypes.string,
  loading: PropTypes.bool,
  opened: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
};

CollapsedSendMessagePopup.defaultProps = {
  profiles: [],
};

export default injectIntl(CollapsedSendMessagePopup);



// WEBPACK FOOTER //
// ./src/components/common/CollapsedSendMessagePopup/index.jsx